const defaultState = () => {
  return {
    organizations: [],
    organizationsLoaded: false,
    editedOrganization: {},
    memberOrganization: {},
    organizationMembersResponseObject: {},
    membersResponseObjectLoaded: false,
    mobileOrganization: {},
    mobileOrganizationLoaded: false,
    organizationChallenges: [],
    organizationChallengesLoaded: false,
    organizationTeams: [],
    organizationTeamsLoaded: false
  };
};

export default defaultState;
